import axios from '../axios'

export const getComplaintList = (data) => {
  return axios({
    url: '/console/edu/complaint/getComplaintList',
    method: 'GET',
    data: data
  })
}

export const getComplaintDetail = (data) => {
  return axios({
    url: '/console/edu/complaint/getComplaintDetail',
    method: 'GET',
    data: data
  })
}
export const rejectComplaint = (data) => {
  return axios({
    url: '/console/edu/complaint/rejectComplaint',
    method: 'GET',
    data: data
  })
}
export const acceptComplaint = (data) => {
  return axios({
    url: '/console/edu/complaint/acceptComplaint',
    method: 'GET',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/http/moudules/feedback.js